import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { BgImg, DashboardCard, UserList } from '../styles/dialpadstyle';
import PropTypes from 'prop-types';
import { Bar, Doughnut, Pie } from 'react-chartjs-2';
import { ChartWrapper, InsightTitle } from '../styles/main';

export class CallDashboardTheme extends Component {

    renderBox(image, num, title) {
        const { __ } = this.context;
        return (
            <Col md={6} style={{ padding: '0px' }}>
                <DashboardCard>
                    <BgImg>
                        <img src={__(image)} width="20" height="20" />
                    </BgImg>
                    <h6>{__(num)}</h6>
                    <p>{__(title)}</p>
                </DashboardCard>
            </Col>
        );
    }

    renderBoxRed(image, num, title) {
        const { __ } = this.context;
        return (
            <Col md={6} style={{ padding: '0px' }}>
                <DashboardCard>
                    <BgImg style={{background: '#e7b8b8'}}>
                        <img src={__(image)} width="20" height="20" />
                    </BgImg>
                    <h6>{__(num)}</h6>
                    <p>{__(title)}</p>
                </DashboardCard>
            </Col>
        );
    }

    renderTitle(title) {
        const { __ } = this.context;
        return (
            <InsightTitle style={{ margin: '0px', textAlign: 'center' }}>
                {__(title)}
            </InsightTitle>
        );
    }


    render() {

        const data = {
            labels: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            datasets: [{
                label: '',
                data: [65, 59, 80, 81, 56, 55, 40],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                    'rgba(255, 205, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(201, 203, 207, 0.2)'
                ],
                borderColor: [
                    'rgb(255, 99, 132)',
                    'rgb(255, 159, 64)',
                    'rgb(255, 205, 86)',
                    'rgb(75, 192, 192)',
                    'rgb(54, 162, 235)',
                    'rgb(153, 102, 255)',
                    'rgb(201, 203, 207)'
                ],
                borderWidth: 1
            }]
        };

        const dataPie = {
            labels: [
                'Mobile',
                'Web'
            ],
            datasets: [{
                label: '',
                data: [300, 50],
                backgroundColor: [
                    '#0155D2',
                    '#eef3fa'
                ],
                hoverOffset: 4
            }]
        };

        const options = {
            scales: {
                xAxes: [
                    {
                        stacked: true,
                        gridLines: {
                            display: false
                        },
                        barPercentage: 0.5
                    }
                ],
                yAxes: [
                    {
                        stacked: true,
                        gridLines: {
                            display: false
                        },
                        barPercentage: 0.5,
                        grid: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                    }
                ]
            }
        };


        return (
            <span>
                <UserList style={{height: '400px', overflowX: 'hidden'}}>
                    <Row>
                        {this.renderBox(
                            '/images/totalCalls.png',
                            '1800',
                            'Total calls'
                        )}
                        {this.renderBox(
                            '/images/completeCalls.png',
                            '1500',
                            'Completed calls'
                        )}
                        {this.renderBox(
                            '/images/scheduleCalls.png',
                            '1800',
                            'Scheduled calls'
                        )}
                        {this.renderBoxRed(
                            '/images/missedCalls.png',
                            '1500',
                            'Missed calls'
                        )}
                    </Row>
                    <ChartWrapper height={"400px"} >
                        {this.renderTitle('Average Response Time')}
                        <Bar
                            ref="chart"
                            data={data}
                            options={options}
                        />
                    </ChartWrapper>
                    <ChartWrapper height={"400px"} style={{marginTop: '10px'}}>
                        {this.renderTitle('User Device')}
                        <Doughnut
                            ref="chart"
                            data={dataPie}
                            options={options}
                        />
                    </ChartWrapper>
                </UserList>
            </span>
        )
    }
}

CallDashboardTheme.contextTypes = {
    __: PropTypes.func
};

export default CallDashboardTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallDashboardTheme.js